import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, SectionLabel } from "./motion";
import { useLang } from "@/LanguageContext";
import { IMAGES } from "@/content";

export default function Proven() {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  return (
    <section id="proven" ref={ref} data-testid="proven-section" className="relative py-24 lg:py-36 bg-navy overflow-hidden">
      <motion.div style={{ y }} className="absolute inset-0 z-0 opacity-20">
        <img src={IMAGES.euFlags} alt="" className="w-full h-full object-cover" />
      </motion.div>
      <div className="absolute inset-0 z-10 bg-gradient-to-b from-navy via-navy/90 to-navy" />

      <div className="relative z-20 mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="max-w-3xl">
          <Reveal><SectionLabel>{t.proven.eyebrow}</SectionLabel></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-white mt-6 tracking-[-0.01em]">{t.proven.title}</h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-white/65 text-base sm:text-lg leading-relaxed mt-8">{t.proven.lead}</p>
          </Reveal>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {t.proven.items.map((item, i) => (
            <Reveal key={i} delay={i * 0.08} y={50}>
              <div className="h-full border border-white/10 rounded-sm p-8 bg-surface/50 backdrop-blur-sm hover:border-gold/40 transition-colors duration-500">
                <h3 className="font-serif text-xl text-gold">{item.title}</h3>
                <p className="text-white/65 leading-relaxed mt-4">{item.body}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-8 border-t border-white/10 pt-12">
          {t.proven.stats.map((s, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div data-testid={`proven-stat-${i}`}>
                <div className="font-serif text-5xl lg:text-6xl text-gold">{s.value}</div>
                <div className="text-sm text-white/55 mt-3 leading-relaxed max-w-xs">{s.label}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
